<template>
	<div ref="swiperBox" class="box-test">
		
		<!-- <div>132</div> -->
		<!-- <div class="player-container">
			<vue-core-video-player :src="videoSource" :cover="cover" :title="title" autoplay loop="true" />
		</div> -->
		<!-- <video controls style="width: 100%;">
			<source src="https://osswm2.oss-us-west-1.aliyuncs.com/Product-1/video/%E8%80%B3%E6%9C%BA2.MP4"
				type="video/webm">
			您的浏览器不支持 video 标签
		</video> -->
		<!-- banner轮播 -->
		<!-- <van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay> -->

		<!-- <div ref="box" class="box-test" @click="animateTest"></div> -->

		<div v-if="show" class="swiper-container" :class="'swiper-container' + idTime"  style="width: 100%;" :id="'mySwiper' + idTime" :style="{
				...getBorder(),
				...getBorderRadius(),
				...getBg(selectdItem),
				// ...getPadding(selectdItem),
				...getMargin(selectdItem),
				height:equipment=='pc'?selectdItem.preStyle.selfStyle.height + 'px' : selectdItem.preStyle.selfStyle.phoneHeight + 'px',
				// height:selectdItem.preStyle.selfStyle.height + 'px',
				'--fontSize':selectdItem.preStyle.selfStyle.navBtnSize + 'px',
				'--btnColor':selectdItem.preStyle.selfStyle.navBtnColor,
				'--indicatorColor':selectdItem.preStyle.selfStyle.indicatorColor,
			}">
			<div class="swiper-wrapper" style="max-width: 100%;" :style="{
			}">
				<div @click="hrefNavTo(item)"
					style="cursor: pointer;position: relative;display: flex;justify-content: center;align-items: center;"
					class="swiper-slide" v-for="(item,index) in getList()" :key="index">

					<van-loading style="position: absolute;z-index: 10000000000000000000000000;" v-if="loading"
						color="#7d7d7d" type="spinner" />

					<video :loop="item.loop" muted  :playsinline="true"  :webkit-playsinline="true" :autoplay="item.isAuto" :controls="item.control"
						v-if="item.type == 'video'" :style="{
						height:equipment=='pc'?selectdItem.preStyle.selfStyle.height + 'px' : selectdItem.preStyle.selfStyle.phoneHeight + 'px',
					}" style="width: 100%;object-fit: cover;position: absolute;z-index: 10;height: 100%;">
						<source :src="item.url" type="video/mp4">
					</video>

					<img v-if="item.type == 'img'" :style="{
						height:equipment=='pc'?selectdItem.preStyle.selfStyle.height + 'px' : selectdItem.preStyle.selfStyle.phoneHeight + 'px',
					}" style="width: 100%;object-fit: cover;position: absolute;z-index: 10;" :src="item.url" alt="" />

					<div :class="idTime + 'animate_' + levleIndex + '_'  + index" @click.stop.prevent="hrefNavTo(levleItem)"
						v-if="levleItem.type == 'text'" @mouseleave.stop.prevent="levelEnterIndex = -1"
						@mouseenter.stop.prevent="levelEnterIndex = levleItem.type +  levleIndex" :style="{
						...getLevelPosition(levleItem,levleIndex),
						...getLevelStyle(levleItem,levleIndex),
						zIndex:levleItem.zIndex + 20
					}" style="position: absolute;z-index: 20;" v-for="(levleItem,levleIndex) in item.levelList" :key="levleIndex">
						<div v-if="levleItem.type == 'text'" style="width: fit-content;">
							{{levleItem.tit}}
						</div>
					</div>


					<div v-if="levleItem.type == 'img'" @mouseleave.stop.prevent="levelEnterIndex = -1"
						@mouseenter.stop.prevent="levelEnterIndex = levleItem.type +  levleIndex" :style="{
						...getLevelPosition(levleItem,levleIndex),
						zIndex:levleItem.zIndex + 20
					}" @click.stop.prevent="hrefNavTo(levleItem)" style="position: absolute;"
						v-for="(levleItem,levleIndex) in item.levelList" :key="levleIndex">

						<div :class="idTime + 'animate_' + levleIndex + '_'  + index"
							style="max-width: 100%;max-height: 100%;display: flex;align-items: center;justify-content: center;"
							:style="{
							aspectRatio: getAspectRatioImg(levleItem),
							// aspectRatio:`${equipment == 'pc'?levleItem.width:levleItem.phoneWidth} / ${equipment == 'pc'?levleItem.height: levleItem.phoneHeight}`
						}">
							<img @mouseleave.stop.prevent="levelEnterIndex = -1"
								@mouseenter.stop.prevent="levelEnterIndex = levleItem.type +  levleIndex"
								style="max-width: 100%;max-height: 100%;" v-if="levleItem.type == 'img'" :style="{
								width:equipment == 'pc'?levleItem.width + 'px':levleItem.phoneWidth + 'px',
								height:equipment == 'pc'?levleItem.height + 'px': levleItem.phoneHeight + 'px',
								objectFit: levleItem.mode,
								...getLevelStyle(levleItem,levleIndex),
							}" :src="levleItem.url" />
						</div>
					</div>

					<div :class="idTime + 'animate_' + levleIndex + '_'  + index" v-if="levleItem.type == 'video'"
						@mouseleave.stop.prevent="levelEnterIndex = -1"
						@mouseenter.stop.prevent="levelEnterIndex = levleItem.type +  levleIndex" :style="{
						...getLevelPosition(levleItem,levleIndex),
						zIndex:levleItem.zIndex + 20
					}" style="position: absolute;" v-for="(levleItem,levleIndex) in item.levelList" :key="levleIndex">

						<div style="max-width: 100%;max-height: 100%;display: flex;align-items: center;justify-content: center;"
							:style="{
							aspectRatio:`${equipment == 'pc'?levleItem.width:levleItem.phoneWidth} / ${equipment == 'pc'?levleItem.height: levleItem.phoneHeight}`
						}">

							<video :autoplay="levleItem.isAuto" muted :loop="levleItem.loop"
								:controls="levleItem.control" :style="{
								width:equipment == 'pc'?levleItem.width + 'px':levleItem.phoneWidth + 'px',
								height:equipment == 'pc'?levleItem.height + 'px': levleItem.phoneHeight + 'px',
							}" style="object-fit: cover;position: absolute;z-index: 10;">
								<source :src="levleItem.url" type="video/mp4">
							</video>
						</div>
					</div>

					<div :class="idTime + 'animate_' + levleIndex + '_'  + index" @click.stop.prevent="hrefNavTo(levleItem)"
						v-if="levleItem.type == 'video'" :style="{
						zIndex:levleItem.zIndex + 20,
							...getLevelPosition(levleItem,levleIndex),
					}" style="position: absolute;" v-for="(levleItem,levleIndex) in item.levelList" :key="levleIndex">
					</div>
					<div :class="idTime + 'animate_' + levleIndex + '_'  + index" @click.stop.prevent="hrefNavTo(levleItem)"
						v-if="levleItem.type == 'btn'" :style="{
						zIndex:levleItem.zIndex + 20,
							...getLevelPosition(levleItem,levleIndex),
					}" style="position: absolute;" v-for="(levleItem,levleIndex) in item.levelList" :key="levleIndex">
						<button @mousedown="levelClickIndex = levleItem.type + levleIndex"
							@mouseup="levelClickIndex = -1" @mouseleave.stop.prevent="levelEnterIndex = -1"
							@mouseenter.stop.prevent="levelEnterIndex = levleItem.type + levleIndex" :style="{
							...getLevelStyle(levleItem,levleIndex),
						}" type="button" style="cursor: pointer;">{{levleItem.tit}}</button>
					</div>
				</div>
			</div>
			<div v-if="selectdItem.preStyle.selfStyle.isNeedArrow" :class="'swiper-pagination' + idTime"></div>
			<div class="swiper-button-prev" v-if="selectdItem.preStyle.selfStyle.isNeedIndicator"></div>
			<div class="swiper-button-next" v-if="selectdItem.preStyle.selfStyle.isNeedIndicator"></div>
		</div>
	</div>
</template>
<script>
	import {
		getUrl_name
	} from '../../api/all.js'
	import Swiper from 'swiper';
	import {
		throttle
	} from 'lodash';
	import {
		animate,
		engine,
		utils,
		onScroll
	} from 'animejs';
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			isFullWidthKey: {
				type: Number,
				default: 0
			},
		},
		data() {
			return {
				idTime:'id-' + new Date().getTime().toString(36) + '-' + Math.random().toString(36).substr(2, 9),
				initialSlide: 0,
				levelClickIndex: -1,
				levelEnterIndex: -1,
				contentRectWidth: "",
				loading: false,
				show: true,
				videoSource: [{
					src: 'https://osswm2.oss-us-west-1.aliyuncs.com/Product-1/video/%E8%80%B3%E6%9C%BA2.MP4',
					resolution: 360,
				}],
				cover: "https://img1.wxzxzj.com/vpc-example-cover-your-name-c.png",
				title: "你的名字",
				banners: [], // 轮播图数据
				mySwiper: null, // 用于保存Swiper实例
			};
		},
		watch: {
			selectdItem: {
				// immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					let that = this
					that.show = false
					if (this.mySwiper) {
						this.initialSlide = this.mySwiper.realIndex
						console.log('this.initialSlide', this.mySwiper.realIndex)


						this.mySwiper.destroy(); // 销毁旧的Swiper实例
					}
					that.$nextTick(() => {
						that.show = true
						setTimeout(() => {
							that.initSwiper()
						}, 10)

					})
					// this.mySwiper.update()
				}
			},
			isFullWidthKey: {
				// immediate: true,
				handler: function(newVal, oldVal) {
					let that = this
					that.show = false
					if (this.mySwiper) {
						this.mySwiper.destroy(); // 销毁旧的Swiper实例
					}
					that.$nextTick(() => {
						that.show = true
						setTimeout(() => {
							that.initSwiper()

						}, 10)
					})
				}
			},
		},
		mounted() {
			console.log('idTimeidTimeidTime',this.idTime)
			console.log('isFullWidthKeyisFullWidthKeyisFullWidthKey', this.isFullWidthKey)
			this.initSwiper()
			
			if(!this.selectdItem.preStyle.selfStyle.phoneHeight) {
				this.$set(this.selectdItem.preStyle.selfStyle, 'phoneHeight', 100)
			}

			this.selectdItem.compontChildren[0].data.list.forEach(item => {
				if (!item.levelList) {
					this.$set(item, 'levelList', [])
				} else {
					item.levelList.forEach(levelItem => {
						if (!levelItem.animateConfig) {
							this.$set(levelItem, 'animateConfig', [])
						}
					})
				}
			})


		},
		beforeDestroy() {
			// this.observer.disconnect()
		},
		methods: {
			animateLayer() {
				this.selectdItem.compontChildren[0].data.list.forEach((item,index) => {
					item.levelList.forEach((levelItem, levelIndex) => {
						levelItem.animateConfig.forEach((animateItem, animateIndex) => {
							this.createrAnimate(animateItem, animateIndex, levelItem, levelIndex,item,index)
						})
					})
				})
			},



			createrAnimate(animateItem, animateIndex, levelItem, levelIndex,item,index) {
				// top
				// right
				// left
				// bto
				// scale
				// rotate
				// opacity
				let obj = {
					ease: animateItem.ease,
					loop: animateItem.loop,
					duration: animateItem.duration * 1000,
					delay: animateItem.delay * 1000,
					playbackRate: parseInt(animateItem.playbackRate),
				}
				if (animateItem.type == 'topBto') {
					// 上
					obj.y = [{
							from: parseInt(-animateItem.value),
						},
						{
							to: 0,
						}
					]
				}

				if (animateItem.type == 'leftRight') {
					// 左
					obj.x = [{
							from: parseInt(-animateItem.value),
						},
						{
							to: 0,
						}
					]
				}
				
				if (animateItem.type == 'bto') {
					// 下
					obj.y = [{
							from: parseInt(animateItem.value),
						},
						{
							to: 0,
						}
					]
				}
				if (animateItem.type == 'right') {
					// 右
					obj.x = [{
							from: parseInt(animateItem.value),
						},
						{
							to: 0,
						}
					]
				}


				if (animateItem.type == 'scale') {
					obj.scale = [parseFloat(animateItem.value)]
				}
				
				if (animateItem.type == 'scaleSmall') {
					obj.scale = [parseFloat(1/animateItem.value)]
				}
				
				if (animateItem.type == 'rotate') {
					obj.rotate = [{
						to: parseFloat(animateItem.value),
					}]
				}

				if (animateItem.type == 'opacity') {
					obj.opacity = [{
						to: parseFloat(animateItem.value),
					}]
				}
				if(this.type == 'deisgn'){
					const animation = animate(`.${this.idTime}animate_${levelIndex}_${index}`, {
						...obj
					});
				}
				
				if(this.type != 'deisgn'){
					const [container] = utils.$('.scroll-container');
					// const debug = true;
					const scrollObserver = onScroll({
						container,
						target: `.${this.idTime}animate_${levelIndex}_${index}`,
						onEnter: () => {
							console.log('scrollObserver.isInView', scrollObserver.isInView)
							const animation = animate(`.${this.idTime}animate_${levelIndex}_${index}`, {
								...obj
							});
						},
					});
				}

				

			},

			// createrAnimate(animateItem,animateIndex,levelItem,levelIndex){
			// 	const [container] = utils.$('.scroll-container');

			// 	let y = []
			// 	let x = []
			// 	let opacity = []
			// 	let scale = []
			// 	let rotate = []

			// 	animateItem.y.forEach(item=>{
			// 		let temp = {}
			// 		temp[item.type] = parseInt(item.value)
			// 		if(item.duration){
			// 			temp.duration = item.duration * 1000
			// 		}
			// 		if(item.delay){
			// 			temp.delay = item.delay * 1000
			// 		}
			// 		y.push(temp)
			// 	})
			// 	animateItem.x.forEach(item=>{
			// 		let temp = {}
			// 		temp[item.type] = item.value 
			// 		if(item.duration){
			// 			temp.duration = item.duration * 1000
			// 		}
			// 		if(item.delay){
			// 			temp.delay = item.delay * 1000
			// 		}
			// 		x.push(temp)
			// 	})

			// 	animateItem.opacity.forEach(item=>{
			// 		let temp = {}
			// 		temp[item.type] = item.value
			// 		if(item.duration){
			// 			temp.duration = item.duration * 1000
			// 		}
			// 		if(item.delay){
			// 			temp.delay = item.delay * 1000
			// 		}
			// 		opacity.push(temp)
			// 	})
			// 	animateItem.scale.forEach(item=>{
			// 		let temp = {}
			// 		temp[item.type] = item.value
			// 		if(item.duration){
			// 			temp.duration = item.duration * 1000
			// 		}
			// 		if(item.delay){
			// 			temp.delay = item.delay * 1000
			// 		}
			// 		scale.push(temp)
			// 	})
			// 	animateItem.rotate.forEach(item=>{
			// 		let temp = {}
			// 		temp[item.type] = item.value
			// 		if(item.duration){
			// 			temp.duration = item.duration * 1000
			// 		}
			// 		if(item.delay){
			// 			temp.delay = item.delay * 1000
			// 		}
			// 		rotate.push(temp)
			// 	})



			// 	let obj = {
			// 		ease:animateItem.ease,
			// 		loop:animateItem.loop,
			// 		loopDelay:animateItem.loopDelay,
			// 		duration:animateItem.duration * 1000,
			// 		delay:animateItem.delay  * 1000,
			// 		playbackRate:parseInt(animateItem.playbackRate),
			// 		reversed:animateItem.reversed,
			// 	}
			// 	if(y.length > 0) {
			// 		obj.y = y
			// 	}
			// 	if(x.length > 0) {
			// 		obj.x = x
			// 	}
			// 	if(opacity.length > 0) {
			// 		obj.opacity = opacity
			// 	}
			// 	if(scale.length > 0) {
			// 		obj.scale = scale
			// 	}
			// 	if(rotate.length > 0) {
			// 		obj.rotate = rotate
			// 	}
			// 	console.log('objobjobjobj',obj)



			// 	const animation = animate(`.animate_${levelIndex}`, {
			// 		...obj
			// 	});
			// },


			animateTest() {
				// const scrollObserver = onScroll(parameters);
				// const [container] = utils.$('.center');
				const [container] = utils.$('.scroll-container');
				const debug = true;
				let loop = false
				const scrollObserver = onScroll({
					container,
					target: ".box-test",
					debug,
					onEnter: () => {
						console.log('scrollObserver.isInView', scrollObserver.isInView)
						alert(1)
						const animation = animate('.box-test', {
							y: [{
									to: 100,
								},
								{
									to: 0,
									// duration: 800,
									// delay: 100
								}
							],
							duration: 6000,
							reversed: true,
							ease: 'inQuad',
							autoplay: true
						});


					},
				});

				console.log('scrollObserver.isInView', scrollObserver.isInView)


			},


			getAspectRatioImg(item) {

				if (this.equipment == 'pc') {
					if (item.width == item.height) {
						return `1/1`
					} else {
						return `${item.width} / ${item.height}`
					}
				} else {
					if (item.phoneWidth == item.phoneHeight) {
						return `1/1`
					} {
						return `${item.phoneWidth} / ${item.phoneHeight}`
					}
				}

			},
			getLevelStyle(item, index) {
				let style = {}
				if (item.type == 'text' || item.type == 'btn') {
					// 字体
					style.fontSize = item.titSize + 'px'
					style.color = item.titColor
					style.fontFamily = item.titFamily
					if (this.levelEnterIndex == item.type + index) {
						if (item.titHoverColor) {
							style.color = item.titHoverColor
						}
					}
				}



				// 内边距
				style.paddingTop = item.padding[0] + 'px',
					style.paddingBottom = item.padding[2] + 'px',
					style.paddingLeft = item.padding[1] + 'px',
					style.paddingRight = item.padding[3] + 'px'
				// 外边距
				style.marginTop = item.margin[0] + 'px',
					style.marginBottom = item.margin[2] + 'px',
					style.marginLeft = item.margin[1] + 'px',
					style.marginRight = item.margin[3] + 'px'

				// 组件边框
				if (item.border.type && item.border.color) {
					style.borderTop =
						`${item.border.type} ${item.border.borderSize[0]}px ${item.border.color}`
					style.borderLeft =
						`${item.border.type} ${item.border.borderSize[1]}px ${item.border.color}`
					style.borderBottom =
						`${item.border.type} ${item.border.borderSize[2]}px ${item.border.color}`
					style.borderRight =
						`${item.border.type} ${item.border.borderSize[3]}px ${item.border.color}`
				}


				if (item.type == 'btn') {
					if (this.levelEnterIndex == item.type + index && item.btnBorderHoverColor) {
						style.borderTop =
							`${'solid'} ${item.border.borderSize[0]?item.border.borderSize[0]:1}px ${item.btnBorderHoverColor}`
						style.borderLeft =
							`${'solid'} ${item.border.borderSize[1]?item.border.borderSize[0]:1}px ${item.btnBorderHoverColor}`
						style.borderBottom =
							`${'solid'} ${item.border.borderSize[2]?item.border.borderSize[0]:1}px ${item.btnBorderHoverColor}`
						style.borderRight =
							`${'solid'} ${item.border.borderSize[3]?item.border.borderSize[0]:1}px ${item.btnBorderHoverColor}`
					}
				}


				if (item.type == 'btn') {
					if (this.levelClickIndex == item.type + index && item.btnBorderClickColor) {
						style.borderTop =
							`${'solid'} ${item.border.borderSize[0]?item.border.borderSize[0]:1}px ${item.btnBorderClickColor}`
						style.borderLeft =
							`${'solid'} ${item.border.borderSize[1]?item.border.borderSize[0]:1}px ${item.btnBorderClickColor}`
						style.borderBottom =
							`${'solid'} ${item.border.borderSize[2]?item.border.borderSize[0]:1}px ${item.btnBorderClickColor}`
						style.borderRight =
							`${'solid'} ${item.border.borderSize[3]?item.border.borderSize[0]:1}px ${item.btnBorderClickColor}`
					}
				}


				style.borderRadius =
					`${item.border.borderRadius[0]}px ${item.border.borderRadius[1]}px ${item.border.borderRadius[2]}px ${item.border.borderRadius[3]}px`


				if (item.bg.bgtype == 'color') {
					style.background = item.bg.color
				}


				if (item.bg.bgtype && item.bg.bgtype == 'img') {
					if (item.bg.img) {

						let backgroundImage = `url(${item.bg.img})`

						if (item.bg.bgImgWidth) {
							style.backgroundSize = item.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (item.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (item.bg.bgImgHeigth +
								'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (item.bg.type) {
							style.backgroundRepeat = item.bg.type
						}
						if (item.bg.position) {
							style.backgroundPosition = item.bg.position
						}
						style.backgroundImage = backgroundImage
						if (item.bg.type) {
							style.backgroundRepeat = item.bg.type
						}
					}
				}
				if (item.bg.bgtype == 'gradient') {
					style = {
						...style,
						...this.cssStringToObject(item.bg.bgGradient)
					}
				}

				if (item.type == 'btn' && item.btnHoverColor) {
					if (this.levelEnterIndex == item.type + index) {
						style.background = item.btnHoverColor
					}
				}

				if (this.levelClickIndex == item.type + index) {

					if (item.type == 'btn' && item.btnClickColor) {
						style.background = item.btnClickColor
					}
					if (item.type == 'btn' && item.titClickColor) {
						style.color = item.titClickColor
					}
					// let that = this
					// setTimeout(()=>{
					// 	that.levelClickIndex = -1
					// },100)
				}



				return style



			},
			getLevelPosition(item) {
				let style = {}
				if (item.position == 'center') {}
				if (item.position == 'top') {
					style.top = '0px'
				}
				if (item.position == 'bottom') {
					style.bottom = '0px'
				}
				if (item.position == 'left') {
					style.left = '0px'
					style.alignSelf = 'center'
				}
				if (item.position == 'right') {
					style.right = '0px'
					style.alignSelf = 'center'
				}
				return style
			},
			getTitInImgStyle(type, item) {
				console.log('itemitemitem', item)
				let style = {}
				if (item.position == 'center') {}
				if (item.position == 'top') {
					style.top = '0px'
				}
				if (item.position == 'bottom') {
					style.bottom = '0px'
				}
				if (item.position == 'left') {
					style.left = '0px'
					style.alignSelf = 'center'
				}
				if (item.position == 'right') {
					style.right = '0px'
					style.alignSelf = 'center'
				}

				// // 字体
				// style.fontSize = item.tit1Size + 'px'
				// style.color = item.tit1Color
				// style.fontFamily = item.tit1Family

				// if (this.isEnter) {
				// 	if (item.tit1HoverColor) {
				// 		style.color = item.tit1HoverColor
				// 	}
				// }

				// // 背景

				// if (item.tit1Bg.type == '1') {
				// 	style = {
				// 		...style,
				// 		backgroundColor: item.tit1Bg.color
				// 	}
				// }
				// if (item.tit1Bg.type == '2') {
				// 	style = {
				// 		...style,
				// 		...this.cssStringToObject(item.tit1Bg.gradientColor)
				// 	}
				// }

				// // 内边距
				// style.paddingTop = item.tit1Padding[0] + 'px',
				// 	style.paddingBottom = item.tit1Padding[1] + 'px',
				// 	style.paddingLeft = item.tit1Padding[2] + 'px',
				// 	style.paddingRight = item.tit1Padding[3] + 'px'
				// // 外边距
				// style.marginTop = item.tit1Margin[0] + 'px',
				// 	style.marginBottom = item.tit1Margin[1] + 'px',
				// 	style.marginLeft = item.tit1Margin[2] + 'px',
				// 	style.marginRight = item.tit1Margin[3] + 'px'

				// // 组件边框
				// if (item.tit1Border.type && item.tit1Border.color) {
				// 	style.borderTop =
				// 		`${item.tit1Border.type} ${item.tit1Border.borderSize[0]}px ${item.tit1Border.color}`
				// 	style.borderLeft =
				// 		`${item.tit1Border.type} ${item.tit1Border.borderSize[1]}px ${item.tit1Border.color}`
				// 	style.borderBottom =
				// 		`${item.tit1Border.type} ${item.tit1Border.borderSize[2]}px ${item.tit1Border.color}`
				// 	style.borderRight =
				// 		`${item.tit1Border.type} ${item.tit1Border.borderSize[3]}px ${item.tit1Border.color}`
				// }

				// style.borderRadius =
				// 	`${item.tit1Border.borderRadius[0]}px ${item.tit1Border.borderRadius[1]}px ${item.tit1Border.borderRadius[2]}px ${item.tit1Border.borderRadius[3]}px`

				// // tit1InImg
				// // tit2InImg
				// if (!item.tit1InImg) {
				// 	style.width =
				// 		`calc(100% - ${parseInt(item.tit1Padding[2]) + parseInt(item.tit1Padding[3]) + parseInt(item.tit1Margin[2]) + parseInt(item.tit1Margin[3]) + parseInt(item.tit1Border.borderSize[1]) + parseInt(item.tit1Border.borderSize[3])}px)`
				// }

				// console.log('style.widthstyle.width', style)
				return style

			},









			async hrefNavTo(item) {
				if (!item.link) {
					return
				}
				console.log('hrefNavTo', item)
				if (this.type == 'design') {
					return
				}

				if (item.link.cacheLinkIndex == '首页') {
					this.$router.push({
						path: '/'
					})
					return
				}
				if (item.link.cacheLinkIndex == '热销商品') {
					this.$router.push({
						path: '/categories_products/hot'
					})
					this.show = false
					return
				}
				if (item.link.cacheLinkIndex == '最新商品') {
					this.$router.push({
						path: '/categories_products/new'
					})
					this.show = false
					return
				}

				if (item.link.cacheLinkIndex == '浏览最多') {
					this.$router.push({
						path: '/categories_products/visit'
					})
					this.show = false
					return
				}
				if (item.link.cacheLinkIndex == '所有商品') {
					this.$router.push({
						path: '/categories_products/all'
					})
					this.show = false
					return
				}



				if (item.link.cacheLinkIndex == '商品分类') {
					try {
						this.loading = true
						const urlData = await getUrl_name({
							type: "categories",
							id: item.link.link.id
						})
						this.$router.push({
							path: '/categories/' + urlData.data.data
						})
						this.loading = false
					} catch (e) {
						this.loading = false
					}
					return
				}

				if (item.link.cacheLinkIndex == '商品') {

					try {
						this.loading = true
						const urlData = await getUrl_name({
							type: "products",
							id: item.link.link.id
						})

						this.$router.push({
							path: '/products/' + urlData.data.data
						})
						this.loading = false
					} catch (e) {
						this.loading = false
					}
					return
				}


				let url = item.link.link.url

				if (item.link.link.type == '站内链接') {
					// 判断是否是站内链接
					console.log('item.link', item.link)
					console.log(window.location.host)
					if (item.link.link.name.indexOf(window.location.host) != -1) {
						let arr = item.link.link.name.split(window.location.host)
						this.$router.push({
							path: arr[1],
						})
						return
					} else {
						window.open(item.link.link.name);
						return
					}
				}
				if (url) {
					this.$router.push({
						path: '/' + url,
					})
				}
			},


			getList() {
				let arr = []
				this.selectdItem.compontChildren[0].data.list.forEach(item => {
					if (item.url != '') {
						arr.push(item)
					}
				})
				return arr
			},
			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},
			getMargin(e) {
				if (e.preStyle.selfStyle.margin) {
					let style = {
						marginTop: e.preStyle.selfStyle.margin[0] + 'px',
						marginBottom: e.preStyle.selfStyle.margin[1] + 'px',
						marginLeft: e.preStyle.selfStyle.margin[2] + 'px',
						marginRight: e.preStyle.selfStyle.margin[3] + 'px'
					}
					return style
				}

			},
			getPadding(e) {
				let style = {
					paddingTop: e.preStyle.selfStyle.padding[0] + 'px',
					paddingBottom: e.preStyle.selfStyle.padding[1] + 'px',
					paddingLeft: e.preStyle.selfStyle.padding[2] + 'px',
					paddingRight: e.preStyle.selfStyle.padding[3] + 'px'
				}
				return style
			},
			getBg(e) {
				let style = {}
				if (e.preStyle.selfStyle.bg.color && e.preStyle.selfStyle.bg.bgtype == 'color') {
					style.background = e.preStyle.selfStyle.bg.color
				}
				if (e.preStyle.selfStyle.bg.bgtype && e.preStyle.selfStyle.bg.bgtype == 'img') {
					if (e.preStyle.selfStyle.bg.img) {

						let backgroundImage = `url(${e.preStyle.selfStyle.bg.img})`

						if (e.preStyle.selfStyle.bg.bgImgWidth) {
							style.backgroundSize = e.preStyle.selfStyle.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (e.preStyle.selfStyle.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.selfStyle.bg.bgImgHeigth +
								'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
						if (e.preStyle.selfStyle.bg.position) {
							style.backgroundPosition = e.preStyle.selfStyle.bg.position
						}
						style.backgroundImage = backgroundImage
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
					}
				}
				if (e.preStyle.selfStyle.bg.bgtype == 'gradient') {
					style = {
						...style,
						...this.cssStringToObject(e.preStyle.selfStyle.bg.bgGradient)
					}
				}

				return style
			},


			getBorderRadius() {
				let style = {}
				style.borderRadius =
					`${this.selectdItem.preStyle.selfStyle.border.borderRadius[0]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[1]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[2]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[3]}px`
				console.log('getBorderRadius', style)
				return style
			},
			getBorder() {
				if (this.selectdItem.preStyle.selfStyle.border.type && this.selectdItem.preStyle.selfStyle.border.color) {
					let style = {}
					style.borderTop =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[0]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderLeft =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[1]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderBottom =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[2]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderRight =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[3]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					return style
				}
			},


			fetchData() {
				// 模拟异步请求
				setTimeout(() => {
					this.banners = [{
							imgUrl: 'https:\/\/pub-75e171aa9805431591635361c0f059a2.r2.dev\/1\/\u5fae\u8f6f\/707004d4f5d0148831509a03e6e32d0c073aa3b2.jpg'
						},
						{
							imgUrl: 'https:\/\/pub-75e171aa9805431591635361c0f059a2.r2.dev\/1\/\u5fae\u8f6f\/94d2ea04497d07a05ae7d9f3eb260b0ff3b3011c.jpg'
						},
						{
							imgUrl: 'https:\/\/pub-75e171aa9805431591635361c0f059a2.r2.dev\/1\/04443eba37068f2e06cbaf9b5abe10a6.jpg'
						},
					];
				}, 1000);
			},
			initSwiper() {
				// 设置Slide的切换效果，默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）、
				this.mySwiper = new Swiper('#mySwiper' + this.idTime, {
					slidesPerView: this.selectdItem.preStyle.selfStyle.type == 'coverflow' ? 3 : 1,
					centeredSlides: this.selectdItem.preStyle.selfStyle.type == 'coverflow',
					effect: this.selectdItem.preStyle.selfStyle.type,
					loop: this.selectdItem.preStyle.selfStyle.isLoop, // 循环模式
					pagination: {
						el: '.swiper-pagination' + this.idTime, // 分页器
						clickable: true,
					},
					initialSlide: this.initialSlide,
					autoplay: this.selectdItem.preStyle.selfStyle.isAuto,
					navigation: {
						nextEl: '.swiper-button-next', // 下一页按钮
						prevEl: '.swiper-button-prev', // 上一页按钮
					},
				});
				this.$nextTick(() => {
					this.animateLayer()
				})
			},
		},
	};
</script>
<style scoped>
	.swiper-container {
		--swiper-navigation-size: var(--fontSize);
		--swiper-theme-color: var(--btnColor);
		--swiper-pagination-color: var(--indicatorColor);
		/* 两种都可以 */
	}

	/* .box-test {
		width: 100px;
		height: 100px;
		background-color: #41B883;
	} */

	/* .center {
		width: 100%;

		margin: 0 auto;
	}

	.swiper-container {
		width: 100%;
	} */

	/* .swiper-slide img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	} */
</style>